













































































































interface NumValue { value: number }
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["account"]),
    components: {
    }
})
export default class ChartThree extends Vue {
    @Prop([String, Date])
    dateTime!: string;

    @Prop({ type: String })
    navText!: string;

    staffMsg: Analysis.StaffMsg[] = [];
    assistantManagerNum: NumValue[] = [];
    managerNumer: NumValue[] = [];
    accountingNum: NumValue[] = [];
    supervisorNum: NumValue[] = [];
    staffNumber: NumValue[] = [];
    yearMonth: string = "";
    total: number = 0;
    areaArr: any = [];
    accountingTotal: number = 0;
    assistantManagerTotal: number = 0;
    supervisorTotal: number = 0;
    others: number = 0;
    managerNumerTotal: number = 0;
    // canvas 饼状图
    option: any = {};
    // 监听时间切换
    @Watch("dateTime")
    dateTimeChange(val: string) {
        this.yearMonth = val.replace(/-/g, "");
        if (this.navText === "新增") {
            this.fetchData(1);
        }
        else if (this.navText === "减少") {
            this.fetchData(-1);
        }
        else {
            this.fetchData(0);
        }
    }
    mounted() {
        this.yearMonth = this.dateTime.replace(/-/g, "");
        this.fetchData(0);
    }
    //获取表格数据
    fetchData(type: number) {
        let color = "#333";
        this.areaArr = [];
        this.assistantManagerNum = [];
        this.accountingNum = [];
        this.supervisorNum = [];
        this.staffNumber = [];
        this.managerNumer = []
        Vue.axios
            .post(`account/staffnumber`, {
                endPeriod: this.yearMonth,
                accounterNo: this.$store.state.account.no,
                countDir: type
            })
            .then(res => {
                this.staffMsg = res.data;
                for (var i = 0; i < res.data.length; i++) {
                    this.areaArr.push({
                        value: res.data[i].area,
                        textStyle: { color: color }
                    });
                    this.assistantManagerNum.push({
                        value: res.data[i].assistantNum
                    });
                    this.accountingNum.push({
                        value: res.data[i].accountingNum
                    });
                    this.supervisorNum.push({
                        value: res.data[i].chargeNum
                    });
                    this.staffNumber.push({
                        value: res.data[i].staffNumber
                    });
                    this.managerNumer.push({
                        value: res.data[i].managerNumer
                    });
                }
                var supervisorTotal = 0;
                for (var i = 0; i < this.supervisorNum.length; i++) {
                    supervisorTotal += this.supervisorNum[i].value;
                }
                this.supervisorTotal = supervisorTotal;

                var accountingTotal = 0;
                for (var i = 0; i < this.accountingNum.length; i++) {
                    accountingTotal += this.accountingNum[i].value;
                }
                this.accountingTotal = accountingTotal;
                var assistantManagerTotal = 0;
                for (var i = 0; i < this.assistantManagerNum.length; i++) {
                    assistantManagerTotal += this.assistantManagerNum[i].value;
                }
                this.assistantManagerTotal = assistantManagerTotal;
                var managerNumerTotal = 0;
                for (var i = 0; i < this.managerNumer.length; i++) {
                    managerNumerTotal += this.managerNumer[i].value;
                }
                this.managerNumerTotal = managerNumerTotal
                this.total = managerNumerTotal + assistantManagerTotal + accountingTotal + supervisorTotal
                this.canvasShow(
                    "canvas",
                    this.assistantManagerTotal,
                    this.accountingTotal,
                    this.supervisorTotal,
                    this.managerNumerTotal
                );
                this.loadChart();
            });
    }
    canvasShow(id: string, num1: number, num2: number, num3: number, num4: number) {
        let c: any = document.getElementById(id);
        let ctx = c.getContext("2d");
        if (num1 + num2 + num3 + num4 == 0) {
            ctx.lineWidth = 18;
            ctx.strokeStyle = "grey";
            ctx.beginPath();
            ctx.arc(80, 80, 70, -Math.PI / 2, (3 * Math.PI) / 2, false);
            ctx.stroke();
            ctx.closePath();
            return;
        }
        let end1 = (num1 / (num1 + num2 + num3 + num4)) * 360 - 90;
        let end2 = ((num2 + num1) / (num1 + num2 + num3 + num4)) * 360 - 90;
        let end3 =
            ((num3 + num2 + num1) / (num1 + num2 + num3 + num4)) * 360 - 90;

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#34c2c1";
        ctx.beginPath();
        ctx.arc(80, 80, 70, -Math.PI / 2, (Math.PI / 180) * end1, false);
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#ffc339";
        ctx.beginPath();
        ctx.arc(
            80,
            80,
            70,
            (Math.PI / 180) * end1,
            (Math.PI / 180) * end2,
            false
        );
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#fd7646";
        ctx.beginPath();
        ctx.arc(
            80,
            80,
            70,
            (Math.PI / 180) * end2,
            (Math.PI / 180) * end3,
            false
        );
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#b7d856";
        ctx.beginPath();
        ctx.arc(80, 80, 70, (Math.PI / 180) * end3, (3 * Math.PI) / 2, false);
        ctx.stroke();
        ctx.closePath();
    }
    // 柱状图数据
    loadChart() {
        let color = "#333";
        this.option = {
            title: {
                text: "全国员工数",
                textStyle: {
                    color: color,
                    fontSize: "15"
                },
                left: "250",
                top: "7"
            },
            tooltip: {
                trigger: "axis",
                formatter: "{a0}: {c0}人<br />{a1}: {c1}人<br />{a2}: {c2}人<br />{a3}: {c3}人",
                axisPointer: {
                    type: "line",
                }
            },
            grid: {
                top: "60",
                bottom: "40",
                right: "100"
            },
            legend: {
                data: [{ name: "经理", icon: "circle" }, { name: "主管", icon: "circle" }, { name: "会计", icon: "circle" }, { name: "助理", icon: "circle" }, { name: "总计", icon: "circle" }],
                textStyle: { fontSize: "12", color: color },
                itemWidth: 6,
                itemHeight: 6,
                orient: "vertical",
                right: "0",
                top: "35%"
            },
            xAxis: [
                {
                    type: "category",
                    data: this.areaArr,
                    axisLine: { lineStyle: { color: "#dedede" } },
                    axisTick: { lineStyle: { color: "white" } }
                }
            ],
            yAxis: [
                {
                    type: "value",
                    offset: 10,
                    axisLine: {
                        show: false
                    },
                    axisTick: { lineStyle: { color: "white" } },
                    axisLabel: {
                        formatter(value: any, index: number) {
                            if (index === 0) {
                                return value + " (人)";
                            } else {
                                return value;
                            }
                        },
                        color: color
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#eeeeee"
                        }
                    }
                },
                { show: false },
                { show: false },
                { show: false }
            ],
            series: [
                {
                    name: "经理",
                    type: "bar",
                    data: this.managerNumer,
                    itemStyle: {
                        normal: {
                            color: "#b7d856"
                        }
                    }
                },
                {
                    name: "主管",
                    type: "bar",
                    data: this.supervisorNum,
                    itemStyle: {
                        normal: {
                            color: "#34c2c1"
                        }
                    }
                },
                {
                    name: "会计",
                    type: "bar",
                    data: this.accountingNum,
                    itemStyle: {
                        normal: {
                            color: "#ffc339"
                        }
                    }
                },
                {
                    name: "助理",
                    type: "bar",
                    data: this.assistantManagerNum,
                    itemStyle: {
                        normal: {
                            color: "#fd7645"
                        }
                    }
                },
                {
                    name: "总计",
                    type: "line",
                    data: this.staffNumber,
                    lineStyle: {
                        normal: {
                            color: "#e02f12"
                        }
                    }
                }
            ]
        };
    }
}
